import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledPrice = styled.div`
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  background-color: ${th('colors.pickledBluewood')};
  color: ${th('colors.white')};

  @media ${sizes.desktop} {
    width: 385px;
    border-radius: 24px;
  }
`;

export const SummaryHeading = styled.div`
  padding: 16px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: 0.04em;
  border-bottom: 1px solid ${th('colors.pickledBluewood2')};
`;

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
`;

export const InfoRow = styled.div`
  display: flex;
  gap: 16px;
`;

export const ItemTexts = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;

  > :not(:first-child) {
    font-weight: 500;
  }
`;

export const SummaryItemBg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
`;

export const CoverageBg = styled(SummaryItemBg)`
  background-color: ${th('colors.fountainBlue')};
`;

export const MembersBg = styled(SummaryItemBg)`
  background-color: ${th('colors.confetti')};
`;

export const AddonsBg = styled(SummaryItemBg)`
  background-color: ${th('colors.porsche')};
`;

export const CostRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Total = styled.div`
  padding: 24px 16px 32px;
  border-top: 1px solid ${th('colors.pickledBluewood2')};
`;

export const TotalPriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TotalText = styled.div`
  font-weight: 500;
`;

export const TotalPrice = styled.div`
  font-size: 40px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.8px;
`;
